import { Canvas } from "fabric/fabric-impl"
import editModes from "../../input/editModes"
import { drawLine } from "../graphics/drawConnection"
import NodeTargeting from "../graphics/ui/NodeTargeting"
import ManaNode from "../mana/nodes/ManaNode"
import CastingEntity from "../physics/CastingEntity"
import PhysicsWorld from "./PhysicsWorld"
import World from "./World"

export default class ManaWorld extends World<Canvas> {

	private nodeTargeting
	private renderInterval = undefined as any

	caster
	physicsWorld

	constructor(caster: CastingEntity, physicsWorld: PhysicsWorld = caster.world) {
		super()

		this.caster = caster
		this.physicsWorld = physicsWorld

		this.nodeTargeting = new NodeTargeting({
			onNodeAdd: (x, y) => {
				const selectedNode = editModes.selectedNode
				if (selectedNode) {
					const NodeKlass = selectedNode.create

					this.add(new NodeKlass({ x, y, world: this }))
				}
			}
		})

		this.add(this.nodeTargeting)
	}

	bindCanvas(canvas: (undefined | Canvas)) {

		if (!canvas && this.canvas) {
			// remove onremove event to disable wacky interactions on unmount
			this.canvas.off('object:removed')
		}

		super.bindCanvas(canvas)

		if (canvas) {
			this.getItems().forEach(node => {
				if (node instanceof ManaNode) {
					node.connections.forEach(connection => {
						drawLine(canvas, node.graphics, connection.graphics)
					})
				}
			})
		}

		if (canvas) {
			this.renderInterval = setInterval(() => {

				canvas.requestRenderAll()

			}, 1000 / 60)
		} else {
			clearInterval(this.renderInterval)
		}
	}

}